module.exports = __webpack_public_path__ + "img/Slika1_2021.de87b9d6.png";